import { useEffect, useState } from "react";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { ClockBlackIcon, DangerRoundRedIcon, EyeIcon, FilterIcon, MailGreyIcon, TelephoneIcon, UserActiveBlackIcon, UsersGroupBlackIcon, VerifyBlackIcon } from "../../../assets/icons";
import { userService } from "../../../services/userService";
import { UserTableInfoDTO } from "../../../models/user/user.response";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import { ToLocalDateString } from "../../../utils/dateFormater";
import { Switch } from "@mui/material";
import UserInfoView from "./UserInfoView";


//TO DO: Dodati poslednju prijavu 
const UsersPage: React.FC = () => {

    const [isUserInfoViewOpen, setIsUserInfoViewOpen] = useState<boolean>(false);

    const [users, setUsers] = useState<UserTableInfoDTO[]>([]);
    const [selectedUserId, setSelectedUserId] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    useEffect(() => {
        fetchUsers();
    }, []);


    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await userService.getUserWithClientProfile();

            if (response.data && response.success) {
                setUsers(response.data)
            } else {
                notify("error", "Greska pri dobavljanju korisnika", response.message);
            }
        } catch (error: any) {
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false)
        }
    };


    if (loading) {
        return <Loader />
    }

    return (
        <>

            {isUserInfoViewOpen &&
                <UserInfoView
                    id={selectedUserId}
                    onClose={() => setIsUserInfoViewOpen(false)}
                />
            }

            <section className="users-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Registrovani Korisnici</h2>
                                <div className="text-block">
                                    Pregled i upravljanje svim registrovanim korisnicima sistema<br />
                                </div>
                            </div>
                        </div>
                        <div className="list-stats-block-div">
                            <div className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Ukupno</div>
                                    <div className="list-stats-number-text">{users.length}</div>
                                </div>
                                <div className="div-block-11">
                                    <img loading="lazy" src={UsersGroupBlackIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                            <div className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Aktivni</div>
                                    <div className="list-stats-number-text">{users.filter(u => u.isActive === true).length}</div>
                                </div>
                                <div className="div-block-11 green">
                                    <img loading="lazy" src={UserActiveBlackIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                            <div className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Verifikovani</div>
                                    <div className="list-stats-number-text alert-fc">{users.filter(u => u.isVerifiedEmail === true).length}</div>
                                </div>
                                <div className="div-block-11 purple">
                                    <img loading="lazy" src={VerifyBlackIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                            <div className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Aktivni (7d)</div>
                                    <div className="list-stats-number-text">TO DO</div>
                                </div>
                                <div className="div-block-11 blue">
                                    <img loading="lazy" src={ClockBlackIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                            <div id="w-node-_66e87063-5080-098f-022f-64d414eec614-7969b2d6" className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Aktivni (30d)</div>
                                    <div className="list-stats-number-text">TO DO</div>
                                </div>
                                <div className="div-block-11 blue dark">
                                    <img loading="lazy" src={ClockBlackIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div filters">
                            <form className="form-11">
                                <input className="form-input grey w-input" placeholder="Pretrazi po imenu, email-u, tel...." type="text" />
                                <select className="form-select auto-width w-select">
                                    <option value="">Svi</option>
                                </select>
                                <select className="form-select auto-width w-select">
                                    <option value="">Svi</option>
                                </select>
                                <div className="sort-icon-div">
                                    <img src={FilterIcon} loading="lazy" alt="" className="icon-size-28" />
                                </div>
                            </form>
                        </div>
                        <div className="admin-settings-box-div table-block-div">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Korisnici</div>
                                    <div className="list-header-description">
                                        Pregled svih korisnika u sistemu<br />
                                    </div>
                                </div>
                            </div>
                            <div className="list-div">
                                <div className="list-row-div list-header-row users">
                                    <div id="w-node-_66e87063-5080-098f-022f-64d414eec632-7969b2d6">Korisnik</div>
                                    <div>Kontakt</div>
                                    <div>Email verifikacija</div>
                                    <div>Porudžbine</div>
                                    <div>Potrošeno</div>
                                    <div>Poslednja prijava</div>
                                    <div>Registrovan</div>
                                    <div>Status</div>
                                    <div id="w-node-_9326279f-6a6e-c1db-67c5-f7c11d5d29d8-7969b2d6">Akcije</div>
                                </div>

                                {users.map(user => (
                                    <div className="list-row-div users" key={user.id}>
                                        <div className="list-column-div" id="w-node-_00b3335e-1e15-eb28-6dc0-cad8040a573a-7969b2d6">
                                            <img src={user.imageUrl + "@lg.webp"} loading="lazy" alt="" className="image-21" />
                                            <div>{user.fullName}</div>
                                            {/* TO DO: IF REPORTED SHOW ICON BELOW */}
                                            {/* <img src={DangerRoundRedIcon} loading="lazy" alt="" className="icon-size-16" style={{ marginLeft: "-5px" }} /> */}
                                        </div>
                                        <div className="list-column-div vertical">
                                            <div className="list-column-div">
                                                <img src={MailGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                                <div>{user.email}</div>
                                            </div>
                                            <div className="list-column-div">
                                                <img src={TelephoneIcon} loading="lazy" alt="" className="icon-size-20" />
                                                <div>{user.phoneNumber}</div>
                                            </div>
                                        </div>
                                        {user.isVerifiedEmail ? (
                                            <div className="small-box-div light-green-bg">
                                                <div>
                                                    <strong>Potvrđen</strong>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="small-box-div gre-bg">
                                                <div>
                                                    <strong>Čeka se</strong>
                                                </div>
                                            </div>
                                        )}
                                        <div>{user.ordersCount}</div>
                                        <div>{user.moneySpent} RSD</div>
                                        <div>Pre 1h</div>
                                        <div>{ToLocalDateString(user.createdAt.toString())}</div>
                                        <Switch
                                            checked={user.isActive}
                                        />
                                        <div id="w-node-_66e87063-5080-098f-022f-64d414eec652-7969b2d6" className="table-row-action-btns-div" onClick={() => {setIsUserInfoViewOpen(true); setSelectedUserId(user.id)}}>
                                            <img src={EyeIcon} loading="lazy" alt="" className="icon-size-24" />
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
    
        </>
    );
};

export default UsersPage;